import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDialogModule } from '@angular/material/dialog';
import { LocationStrategy,
    HashLocationStrategy, 
    PathLocationStrategy} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
/*Added by Radha*/
import { GalleryModule } from '@ngx-gallery/core';
import { GallerizeModule } from '@ngx-gallery/gallerize';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ExportAsService } from 'ngx-export-as';
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppGlobal } from './app.global';
import { CoreModule } from './core/core.module';
import { interceptorsProviders } from './core/interceptor/interceptors';
import { AppPreloadingStrategy } from './core/preloading-strategy/preloading-strategy';
import { SharedModule } from './shared/shared.module';
import { ThemeOptions } from './theme-options';
import { SupplierComponent } from './modules/supplier/supplier.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RatingsComponent } from './ratings/ratings.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { CustomDialogWrapperComponent } from './modules/custom-dialog-wrapper/custom-dialog-wrapper.component';
@NgModule({
    declarations: [
        AppComponent,
        RatingsComponent,
        CustomDialogWrapperComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        SlickCarouselModule,
        BrowserAnimationsModule,
        GoogleMapsModule,
        SharedModule,
        CoreModule,
        NgxUiLoaderModule,
        NgxSliderModule,
        ToastrModule.forRoot(),
        /*added by Radha*/
        GalleryModule,
        LightboxModule,
        GallerizeModule,
        MatDialogModule,
        SocialLoginModule,
        CollapseModule,
        NgbModule,
        NgMultiSelectDropDownModule,
        TimepickerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        NgProgressModule.withConfig({
            spinner: false,
            color: "#1a9ad3",
            thick: true
        }),
        MatIconModule, // Add this
        MatDialogModule,
        NgProgressHttpModule,
        AppRoutingModule // always keep at the end of the array

    ],
    
    providers: [{provide:LocationStrategy, useClass: PathLocationStrategy},
        
        ...interceptorsProviders,
        {
            provide: DEFAULT_CURRENCY_CODE, useValue: 'USD',
        },
        
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [

                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(
                            '55994952558-ekvoa8fsjkhgeb42u017bbjr6q8lueeg.apps.googleusercontent.com'
                        )
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('633592978261756')
                    }
                ]
                ,
                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        },
        ExportAsService,
        AppGlobal,
        AppPreloadingStrategy,
        ThemeOptions
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

